// import { useState, useEffect } from "react";
// import { Table, Card, CardHeader, CardTitle } from "reactstrap";
// import Select from "react-select";
// import { H5 } from "../../../../AbstractElements";
// import { NetProfitList } from "../../../../apiController";
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import DataTable from "react-data-table-component";

// const NetValue = () => {
//     const [netValue, setNetValue] = useState([]);
//     const [modal, setModal] = useState(false);
//     const [selectedMonthID, setSelectedMonthID] = useState(null);
//     const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Store selected year

//     const toggle = (monthID) => {
//         setSelectedMonthID(monthID);
//         setModal(!modal);
//     };

//     const findNetValue = (getData) => {
//         const income =
//             (getData.patient_clinic_income
//                 ? getData.patient_clinic_income
//                 : 0) +
//             (getData.pharmacy_income ? getData.pharmacy_income : 0);

//         const debit =
//             (getData.pharmacy_account ? getData.pharmacy_account : 0) +
//             (getData.inventory_accounts ? getData.inventory_accounts : 0) +
//             (getData.lab_accounts ? getData.lab_accounts : 0) +
//             (getData.consultant_main ? getData.consultant_main : 0) +
//             (getData.doctor_salary ? getData.doctor_salary : 0) +
//             (getData.staff_salary ? getData.staff_salary : 0) +
//             (getData.stationery_accounts ? getData.stationery_accounts : 0);

//         return income - debit;
//     }

//     const type = netValue
//         .map((main) => {
//             if (main.month === selectedMonthID && main.year === selectedYear) {
//                 const keyValuePairs = [];
//                 let rowIndex = 1;

//                 const formatKey = (key) => {
//                     return key
//                         .split("_")
//                         .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//                         .join(" ");
//                 };

//                 for (let key in main) {
//                     if (key === "year" || key === "month" || key === "date") {
//                         continue;
//                     }
//                     if (main.hasOwnProperty(key)) {
//                         keyValuePairs.push({
//                             ind: rowIndex,
//                             id: main.id,
//                             keyValues: formatKey(key),
//                             values: main[key],
//                         });
//                         rowIndex++;
//                     }
//                 }

//                 return keyValuePairs.length > 0 ? keyValuePairs : null;
//             }

//             return null;
//         })
//         .filter((item) => item !== null)
//         .flat();

//     const monthDataColumns = [
//         { name: "#", selector: (row) => row.ind, sortable: true },
//         {
//             name: "Income / Expense",
//             selector: (row) => row.keyValues,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 <span
//                     style={{
//                         color: row.keyValues.toLowerCase().includes("income")
//                             ? "green"
//                             : "red",
//                     }}
//                 >
//                     {row.keyValues}
//                 </span>
//             ),
//         },
//         {
//             name: "Value",
//             selector: (row) => row.values,
//             sortable: true,
//             center: true,
//             cell: (row) => (
//                 <span
//                     style={{
//                         color: row.keyValues.toLowerCase().includes("income")
//                             ? "green"
//                             : "red",
//                     }}
//                 >
//                     {row.values}
//                 </span>
//             ),
//         },
//     ];

//     const options = [
//         { value: 2024, label: 2024 },
//         { value: 2023, label: 2023 },
//     ];

//     const tableHeader = ["#", "Month", "Total"];
//     const months = [
//         { id: 1, month: "January" },
//         { id: 2, month: "February" },
//         { id: 3, month: "March" },
//         { id: 4, month: "April" },
//         { id: 5, month: "May" },
//         { id: 6, month: "June" },
//         { id: 7, month: "July" },
//         { id: 8, month: "August" },
//         { id: 9, month: "September" },
//         { id: 10, month: "October" },
//         { id: 11, month: "November" },
//         { id: 12, month: "December" },
//     ];

//     useEffect(() => {
//         fetchNetProfitList();
//     }, []);

//     const fetchNetProfitList = async () => {
//         const response = await NetProfitList();
//         if (response.status === true) {
//             setNetValue(response.data);
//         }
//     };

//     return (
//         <Card>
//             <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
//                 <CardTitle>Select Year</CardTitle>
//                 <Select
//                     options={options}
//                     className="js-example-basic-single col-sm-3"
//                     value={options.find((option) => option.value === selectedYear)}
//                     onChange={(option) => setSelectedYear(option.value)}
//                 />
//                 <H5 className="align-self-end">Net Profit</H5>
//             </CardHeader>
//             <Table responsive striped>
//                 <thead>
//                     <tr className="text-center">
//                         {tableHeader.map((heads, i) => (
//                             <th key={i}>{heads}</th>
//                         ))}
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {months.map((data) => (
//                         <tr className="text-center" key={data.id}>
//                             <td>{data.id}</td>
//                             <td>
//                                 <span
//                                     onClick={() => toggle(data.id)}
//                                     style={{ cursor: "pointer" }}
//                                 >
//                                     {data.month}
//                                 </span>
//                             </td>
//                             <td>
//                                 {netValue
//                                     .filter(
//                                         (main) =>
//                                             main.month === data.id && main.year === selectedYear
//                                     )
//                                     .map((main, index) => {
                                        
//                                         // const income =
//                                         //     (main.patient_clinic_income
//                                         //         ? main.patient_clinic_income
//                                         //         : 0) +
//                                         //     (main.pharmacy_income ? main.pharmacy_income : 0);

//                                         // const debit =
//                                         //     (main.pharmacy_account ? main.pharmacy_account : 0) +
//                                         //     (main.inventory_accounts ? main.inventory_accounts : 0) +
//                                         //     (main.lab_accounts ? main.lab_accounts : 0) +
//                                         //     (main.consultant_main ? main.consultant_main : 0) +
//                                         //     (main.doctor_salary ? main.doctor_salary : 0) +
//                                         //     (main.staff_salary ? main.staff_salary : 0) +
//                                         //     (main.stationery_accounts ? main.stationery_accounts : 0);

//                                         // const netvalue = income - debit;
//                                         const netvalue = findNetValue(main)

//                                         return (
//                                             <span
//                                                 key={index}
//                                                 className={
//                                                     netvalue > 0
//                                                         ? "text-success"
//                                                         : netvalue < 0
//                                                             ? "text-danger"
//                                                             : ""
//                                                 }
//                                             >
//                                                 {netvalue || "--"}
//                                             </span>
//                                         );
//                                     })}
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </Table>
//             <Modal isOpen={modal} toggle={() => toggle(null)} size="lg" centered>
//                 <ModalHeader toggle={() => toggle(null)}>
//                     Details for{" "}
//                     {months.find((m) => m.id === selectedMonthID)?.month || "N/A"}
//                 </ModalHeader>
//                 <ModalBody>
//                     <DataTable
//                         data={type}
//                         columns={monthDataColumns}
//                         striped={true}
//                         pagination
//                     />
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="secondary" onClick={() => toggle(null)}>
//                         Cancel
//                     </Button>
//                 </ModalFooter>
//             </Modal>
//         </Card>
//     );
// };

// export default NetValue;




import { useState, useEffect } from "react";
import { Table, Card, CardHeader, CardTitle } from "reactstrap";
import Select from "react-select";
import { H5 } from "../../../../AbstractElements";
import { NetProfitList } from "../../../../apiController";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DataTable from "react-data-table-component";

const NetValue = () => {
    const [netValue, setNetValue] = useState([]);
    const [modal, setModal] = useState(false);
    const [selectedMonthID, setSelectedMonthID] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [modalNetValue, setModalNetValue] = useState(null); 

    const toggle = (monthID, netValue) => { 
        setSelectedMonthID(monthID);
        setModalNetValue(netValue); 
        setModal(!modal);
    };

    const findNetValue = (getData) => {
        const income =
            (getData.patient_clinic_income ? getData.patient_clinic_income : 0) +
            (getData.pharmacy_income ? getData.pharmacy_income : 0);

        const debit =
            (getData.pharmacy_account ? getData.pharmacy_account : 0) +
            (getData.inventory_accounts ? getData.inventory_accounts : 0) +
            (getData.lab_accounts ? getData.lab_accounts : 0) +
            (getData.consultant_main ? getData.consultant_main : 0) +
            (getData.doctor_salary ? getData.doctor_salary : 0) +
            (getData.staff_salary ? getData.staff_salary : 0) +
            (getData.stationery_accounts ? getData.stationery_accounts : 0);

        return income - debit;
    };

    const type = netValue
        .map((main) => {
            if (main.month === selectedMonthID && main.year === selectedYear) {
                const keyValuePairs = [];
                let rowIndex = 1;

                const formatKey = (key) => {
                    return key
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ");
                };

                for (let key in main) {
                    if (key === "year" || key === "month" || key === "date") {
                        continue;
                    }
                    if (main.hasOwnProperty(key)) {
                        keyValuePairs.push({
                            ind: rowIndex,
                            id: main.id,
                            keyValues: formatKey(key),
                            values: main[key],
                        });
                        rowIndex++;
                    }
                }

                return keyValuePairs.length > 0 ? keyValuePairs : null;
            }

            return null;
        })
        .filter((item) => item !== null)
        .flat();

    const monthDataColumns = [
        { name: "#", selector: (row) => row.ind, sortable: true },
        {
            name: "Income / Expense",
            selector: (row) => row.keyValues,
            sortable: true,
            center: true,
            cell: (row) => (
                <span
                    style={{
                        color: row.keyValues.toLowerCase().includes("income")
                            ? "green"
                            : "red",
                    }}
                >
                    {row.keyValues}
                </span>
            ),
        },
        {
            name: "Value",
            selector: (row) => row.values,
            sortable: true,
            center: true,
            cell: (row) => (
                <span
                    style={{
                        color: row.keyValues.toLowerCase().includes("income")
                            ? "green"
                            : "red",
                    }}
                >
                    {row.values}
                </span>
            ),
        },
    ];

    const options = [
        { value: 2024, label: 2024 },
        { value: 2023, label: 2023 },
    ];

    const tableHeader = ["#", "Month", "Total"];
    const months = [
        { id: 1, month: "January" },
        { id: 2, month: "February" },
        { id: 3, month: "March" },
        { id: 4, month: "April" },
        { id: 5, month: "May" },
        { id: 6, month: "June" },
        { id: 7, month: "July" },
        { id: 8, month: "August" },
        { id: 9, month: "September" },
        { id: 10, month: "October" },
        { id: 11, month: "November" },
        { id: 12, month: "December" },
    ];

    useEffect(() => {
        fetchNetProfitList();
    }, []);

    const fetchNetProfitList = async () => {
        const response = await NetProfitList();
        if (response.status === true) {
            setNetValue(response.data);
        }
    };

    return (
        <Card>
            <CardHeader className="d-flex gap-4 justify-content-evenly align-items-center">
                <CardTitle>Select Year</CardTitle>
                <Select
                    options={options}
                    className="js-example-basic-single col-sm-3"
                    value={options.find((option) => option.value === selectedYear)}
                    onChange={(option) => setSelectedYear(option.value)}
                />
                <H5 className="align-self-end">Net Profit</H5>
            </CardHeader>
            <Table responsive striped>
                <thead>
                    <tr className="text-center">
                        {tableHeader.map((heads, i) => (
                            <th key={i}>{heads}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {months.map((data) => {
                        const monthData = netValue.find(
                            (main) => main.month === data.id && main.year === selectedYear
                        );
                        const netvalue = monthData ? findNetValue(monthData) : 0;

                        return (
                            <tr className="text-center" key={data.id}>
                                <td>{data.id}</td>
                                <td>
                                    <span
                                        onClick={() => toggle(data.id, netvalue)} 
                                        style={{ cursor: "pointer" }}
                                    >
                                        {data.month}
                                    </span>
                                </td>
                                <td>
                                    <span
                                        className={
                                            netvalue > 0
                                                ? "text-success"
                                                : netvalue < 0
                                                ? "text-danger"
                                                : ""
                                        }
                                    >
                                        {netvalue || ""}
                                        {/* {netvalue } */}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <Modal isOpen={modal} toggle={() => toggle(null, null)} size="lg" centered>
                <ModalHeader toggle={() => toggle(null, null)}>
                    {months.find((m) => m.id === selectedMonthID)?.month || "N/A"} - Net Value: {modalNetValue}
                </ModalHeader>
                <ModalBody>
                    <DataTable
                        data={type}
                        columns={monthDataColumns}
                        striped={true}
                        pagination
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => toggle(null, null)}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Card>
    );
};

export default NetValue;
